import { SET_LOADER } from './types'

const setLoader = (isLoad) => {
  // eslint-disable-line
  return {
    type: SET_LOADER,
    payload: {
      isLoad,
    },
  }
}
export default setLoader
